module.exports = __webpack_public_path__ + "img/image26.eba26c9e.jpg";